const VERTICAL_TRAVERSAL_CATEGORY = ["elevator", "escalator", "stairs", "ramp"]
const VERTICAL_KIOSK_BREAKPOINT = "@media (min-height:1920px)"

const Q_AUTOPLAY = "autoplay"
const Q_PARENT_CATEGORY_ID = "parentCategoryId"
const Q_SUB_CATEGORY_ID = "subCategoryId"
const Q_ORDINAL = "ordinal"
const Q_VENUE = "venue"

export {
  VERTICAL_TRAVERSAL_CATEGORY,
  VERTICAL_KIOSK_BREAKPOINT,
  Q_AUTOPLAY,
  Q_PARENT_CATEGORY_ID,
  Q_SUB_CATEGORY_ID,
  Q_ORDINAL,
  Q_VENUE,
}
